import { useState } from 'react';
import type { ReactElement } from 'react';

import BpkBottomSheet from '@skyscanner/backpack-web/bpk-component-bottom-sheet';
import type { BpkBottomSheetProps } from '@skyscanner/backpack-web/bpk-component-bottom-sheet';
import { PADDING_TYPE } from '@skyscanner/backpack-web/bpk-component-bottom-sheet/src/BpkBottomSheet';
import { BpkDropdownChip } from '@skyscanner/backpack-web/bpk-component-chip';

type Props = {
  id: string;
  displayText: string;
  title: string;
  accessibilityLabel?: string;
  selected?: boolean;
  disabled?: boolean;
  children: ReactElement;
  bottomSheetProps?: Omit<BpkBottomSheetProps, 'id' | 'onClose' | 'isOpen'>;
  onClick?: () => void;
  usePropagationToClose?: boolean;
};

const DropdownBottomSheet = ({
  accessibilityLabel,
  bottomSheetProps,
  children,
  disabled,
  displayText,
  id,
  onClick,
  selected,
  title,
  usePropagationToClose = true,
}: Props) => {
  const [isBottomSheetOpen, setIsBottomSheetOpen] = useState(false);

  const handleChipClick = () => {
    setIsBottomSheetOpen(true);
    onClick?.();
  };

  const handleBottomSheetClose = () => {
    setIsBottomSheetOpen(false);
  };

  const handlePropagationClick = () => {
    if (usePropagationToClose) {
      setIsBottomSheetOpen(false);
    }
  };

  return (
    <>
      <BpkDropdownChip
        onClick={handleChipClick}
        selected={selected}
        accessibilityLabel={accessibilityLabel ?? displayText}
        disabled={disabled}
        role="button"
        aria-haspopup="dialog"
        aria-controls={id}
      >
        {displayText}
      </BpkDropdownChip>
      <BpkBottomSheet
        id={id}
        title={title}
        ariaLabel={title}
        isOpen={isBottomSheetOpen}
        onClose={handleBottomSheetClose}
        closeOnEscPressed
        closeOnScrimClick
        paddingStyles={{
          top: PADDING_TYPE.none,
          start: PADDING_TYPE.base,
          end: PADDING_TYPE.base,
          bottom: PADDING_TYPE.base,
        }}
        {...bottomSheetProps}
      >
        <div
          role="presentation"
          onKeyUp={() => {}}
          onClick={handlePropagationClick}
        >
          {children}
        </div>
      </BpkBottomSheet>
    </>
  );
};

export default DropdownBottomSheet;
